module.exports = __webpack_public_path__ + "img/icon-Add-Note.e3785465.svg";